module.exports = __webpack_public_path__ + "static/img/bkg-foot.3ccfd9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/syscom/bkg-foot.png
// module id = 03iy
// module chunks = 0